module.exports = __webpack_public_path__ + "img/titleImg2.866ec23c.png";